import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LMContextService } from './lm-context.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMUrlUtilService } from './utils';

export enum RoamingUIProfileResult {
  COMPLETED = 'COMPLETED',
}

@Injectable()
export class LMRoamingUIProfileService {

  constructor(
    private http: HttpClient,
    private lmUrlUtilService: LMUrlUtilService,
    private lmContextService: LMContextService
  ) {
    // no op
  }

  public setMenuV2Viewed(): Observable<RoamingUIProfileResponse> {
    const context = this.lmContextService.getContext();
    const webProfile = context.roamingUIProfile ? context.roamingUIProfile : {};
    webProfile.menuV2GuideViewed = true;

    return this.updateRoamingUIProfile(webProfile);
  }

  public setPreferredWebApp(preferredWebApp: string): Observable<RoamingUIProfileResponse> {
    const context = this.lmContextService.getContext();
    const webProfile = context.roamingUIProfile ? context.roamingUIProfile : {};

    if (webProfile.landingPageDefault && webProfile.landingPageDefault[0]) {
      webProfile.landingPageDefault[0].webApp = preferredWebApp;
      webProfile.landingPageDefault[0].myPage = '';
    } else {
      const prop: LandingPageDefault = {
        webApp:  preferredWebApp,
        myPage: ''
      }
      webProfile.landingPageDefault = [prop];
    }

    return this.updateRoamingUIProfile(webProfile);
  }

  public setLastViewedNotification(timestamp: string): Observable<RoamingUIProfileResponse> {
    const context = this.lmContextService.getContext();
    const webProfile = context.roamingUIProfile ? context.roamingUIProfile : {};
    webProfile.notificationTimeStamp = timestamp;

    return this.updateRoamingUIProfile(webProfile);
  }

  private updateRoamingUIProfile(webProfile: LMRoamingUIProfile): Observable<RoamingUIProfileResponse> {
    let url = this.lmUrlUtilService.getBaseUrl();
    url += '/banner/web';
    url = this.lmUrlUtilService.propagateSessionKeys(url, '?');

    const newWebProfile: LMRoamingUIProfile = {};
    newWebProfile.landingPageDefault = webProfile.landingPageDefault;
    newWebProfile.menuV2GuideViewed = webProfile.menuV2GuideViewed;
    newWebProfile.notificationTimeStamp = webProfile.notificationTimeStamp;

    const data = {
      requestType : 'updateRoamingUIProfile',
      webProfile : newWebProfile
    };

    return this.executeRequest(url, data);
  }

  private executeRequest(url: string, data: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    return <Observable<Response>> this.http.post(url, JSON.stringify(data), { headers }).pipe(
      catchError(error => this._handleError(error)));
  }

  private _handleError(error: Response) {
    return throwError(error || 'Server error');
  }
}

export interface RoamingUIProfileResponse {
  status: string;
  message?: string;
}
